import _cloneDeep from 'lodash/cloneDeep';
import ElementNames from './elementNames';
import { generateQuillOpsFromText } from './quillUtils';
import { ITemplateHistory, ITemplateHistoryImage, ITemplateHistoryText } from '../../models';

function replaceElementText(element: $TSFixMe, payload: string) {
    if (payload) {
        const text = payload || '';

        if (element?.Content?.Quill) {
            element.Content.Quill.ops = generateQuillOpsFromText(element.Content.Quill.ops, text);
        } else {
            element.Content.Text = text;
        }
    }
}

function replaceElementTextByName(root: $TSFixMe, name: $TSFixMe, payload: ITemplateHistoryText) {
    if (!payload) return;

    if (root.Type === 'Text' || (root.Type === 'Rich-Text' && root.Name === name && root.Content)) {
        replaceElementText(root, payload.text);
    }

    if (root.ChildElements) {
        root.ChildElements.forEach((child: $TSFixMe) => replaceElementTextByName(child, name, payload));
    }
}

function replaceMainImageSrc(root: $TSFixMe, image: ITemplateHistoryImage) {
    if (!image) return;
    if (root.Type === 'Image' && root.Name === 'Image') {
        if (root.Content.ImageSource) {
            if (image.aspectRatio) {
                const currentWidth = root?.Style?.size?.width?.value;
                const currentHeight = root?.Style?.size?.height?.value;

                if (currentWidth < currentHeight) {
                    root.Style.size.height.value = currentWidth / image.aspectRatio;
                } else {
                    root.Style.size.width.value = image.aspectRatio * currentHeight;
                }
            }

            root.Content.ImageSource = image.src;
        }
    }

    if (root.ChildElements) {
        root.ChildElements.forEach((child: $TSFixMe) => replaceMainImageSrc(child, image));
    }
}

export default function mergeVisualDesignDataProps(template: $TSFixMe, data: ITemplateHistory) {
    const clonedTemplate = _cloneDeep(template);
    const { title, message, image } = data;
    if (title) {
        replaceElementTextByName(clonedTemplate?.VisualDesign?.RootVisualElement, ElementNames.TITLE, title);
    }

    if (message) {
        replaceElementTextByName(clonedTemplate?.VisualDesign?.RootVisualElement, ElementNames.DESCRIPTION, message);
    }

    if (image) {
        replaceMainImageSrc(clonedTemplate?.VisualDesign?.RootVisualElement, image);
    }

    return clonedTemplate;
}
